import AddCircle from '@material-ui/icons/AddCircle';
import Delete from '@material-ui/icons/Delete';
import {
  DOOR,
  DOOR_CANOPY,
  GATE,
  GLASS_ELEMENT,
  WALL,
  WALL_LIGHTBAND,
  WINDOW,
} from '../../Constants/ObjectTypes';
import { CLONE, REMOVE } from '../../Constants/ItemActions';
import find from 'lodash/find';
import { getOptionAttributeValue, getOptionsByComponentIdentifier } from '../Selectors/Option';

const editableItems = [DOOR, DOOR_CANOPY, GATE, WINDOW, WALL_LIGHTBAND, GLASS_ELEMENT];

const notCloneableItems = [DOOR_CANOPY];

function filterActionsByType(actions, type) {
  return actions.filter(({ action }) => !(action === CLONE && notCloneableItems.indexOf(type) !== -1));
}

export function isEditableItem(type) {
  return editableItems.indexOf(type) !== -1;
}

export function getMenuItems(targetObject, componentOptions, options) {
  const { type } = targetObject.userData;
  const wallElements = getOptionsByComponentIdentifier(componentOptions, 'wall_elements');
  const { titles = {} } = options;
  const wallItems = [
    {
      identifier: GATE,
      title: titles?.[GATE],
      type: GATE,
      children: [],
    },
    {
      identifier: DOOR,
      title: titles?.[DOOR],
      type: DOOR,
      children: [],
    },
    {
      identifier: WINDOW,
      title: titles?.[WINDOW],
      type: WINDOW,
      children: [],
    },
  ];
  wallElements.map((element) => {
    const type = getOptionAttributeValue(element, 'type', '');
    const gates = find(wallItems, { identifier: GATE });
    const doors = find(wallItems, { identifier: DOOR });
    const windows = find(wallItems, { identifier: WINDOW });
    switch (type) {
      case DOOR:
      case DOOR_CANOPY:
        doors.children.push(element);
        break;
      case WALL_LIGHTBAND:
        wallItems.push(element);
        break;
      case GATE:
        gates.children.push(element);
        break;
      case WINDOW:
        windows.children.push(element);
        break;
      default:
        wallItems.push(element);
    }
  });
  if (type === WALL) {
    return wallItems;
  } else if (isEditableItem(type)) {
    return filterActionsByType(editActions, type);
  }
}

const editActions = [
  {
    action: REMOVE,
    IconComponent: Delete,
  },
  {
    action: CLONE,
    IconComponent: AddCircle,
  },
];
